<template>

  <div class="div_prim">

    <el-row :gutter="60">
      <el-col :span="24" class="card-01">
        <el-row :gutter="20">
          <el-col :span="24" class="modal_title middle_blue">Pacienti
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="21">
            <el-row :gutter="30">
              <el-col :span="5">
                <div class="modal_label green">Příjmení, lokalizace</div>
                <el-input
                  clearable
                  placeholder="Zadejte příjmení nebo lokalizaci"
                  v-model="filter_patients.name"
                  class="input-with-select"
                  size="small"
                  @keyup.enter.native="a_patients()"
                  @clear="a_patients()"
                  >
                </el-input>
              </el-col>
              <el-col :span="5">
                <div class="modal_label green">Datum diagnózy</div>
                <el-date-picker
                  type="years"
                  v-model="filter_patients.dat_diag"
                  size="small"
                  style="width: 100%"
                  placeholder="Vyberte letopočty"
                  value-format="yyyy"
                  clearable
                  >
                </el-date-picker>
              </el-col>
              <el-col :span="5">
                <div class="modal_label green">Diagnózy</div>
                  <el-select
                    v-model="filter_patients.diags"
                    placeholder="Vyberte diagnózy"
                    size="small"
                    filterable
                    clearable
                    multiple
                    >
                    <el-option-group
                      v-for="dg in l_diags"
                      :key="dg.dg_name"
                      :label="dg.dg_name">
                      <el-option
                        v-for="item in dg.dg_list"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-option-group>
                  </el-select>
              </el-col>
              <el-col :span="4">
                <div class="modal_label green">Věk</div>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-input
                      type="number"
                      placeholder="Od"
                      v-model="filter_patients.vek_od"
                      controls-position="right"
                      :min="0"
                      :max="20"
                      size="small"
                      >
                    </el-input>
                  </el-col>
                  <el-col :span="12">
                    <el-input
                      type="number"
                      placeholder="Do"
                      v-model="filter_patients.vek_do"
                      controls-position="right"
                      :min="0"
                      :max="20"
                      size="small"
                      >
                    </el-input>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="3">
                <el-tooltip class="item" effect="dark" content="Hledej podle kritérií" placement="top-end">
                  <el-button icon="el-icon-search" size="small" style="background: #74a17c; color: white; margin-top: 30px" @click.native="a_patients()"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Zrušit filtry" placement="top-end">
                  <el-button icon="el-icon-close" size="small"  type="info" style="color: white; margin-top: 30px" @click.native="filter_patient_clear"></el-button>
                </el-tooltip>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <div class="mb-10"></div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="3">
            <el-button :disabled="!loginuser.editor" style="background: #74a17c; color: white; float: right; margin-top: 30px" icon="el-icon-user" size="small" @click="patient_new"> Nový pacient</el-button>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-table
              ref="patients_table"
              :data="patients"
              style="width: 100%; word-break: normal;"
              row-key="id_patient"
              v-loading="loading_patients"
              element-loading-text="Loading..."
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(211, 227, 218, 0.8)"
              :default-sort="{prop:'pat_fullname', order:'ascending'}"
              border
              highlight-current-row
              @current-change="CurrentChange_patients"
              @sort-change="SortChange_patients"
              >
              <el-table-column
                prop="pat_fullname"
                label="Příjmení a jméno"
                width="280"
                sortable="custom"
                >
                <template slot-scope="props">
                  <div style="color: #559f55; font-size: 15px; font-weight: 600;">{{ props.row.pat_surname }} {{ props.row.pat_name }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="pat_birth_date"
                label="Datum narození"
                width="180"
                sortable="custom">
              </el-table-column>
              <el-table-column
                prop="prvni_diagnoza_dat"
                label="Datum 1. diagnózy"
                width="180"
                sortable="custom">
              </el-table-column>
              <el-table-column
                prop="diagnozy_agg"
                label="Diagnózy"
                min-width="500"
                sortable="custom">
                <template slot-scope="props">
                  <div v-for="one in props.row.diagnozy_agg"><span class="modal_dark_blue title-2">{{ one.split("|")[0].replace("{", "").replace("}", "") }}</span> / {{ one.split("|")[1] }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="lok_agg"
                label="Lokalizace nádoru"
                min-width="350"
                sortable="custom">
                <template slot-scope="props">
                  <div v-for="one in props.row.lok_agg"><span class="modal_dark_blue title-2">{{ one }}</span></div>
                </template>
              </el-table-column>
              <el-table-column
                width="180"
                fixed="right"
                label="Akce"
                align="center">
                <template slot-scope="props">
                  <el-tooltip content="Jen pro čtení" placement="top" effect="light" :open-delay="500">
                    <el-button class="btn-grey-lit" size="mini" icon="el-icon-view" @click="patient_show( props.$index, props.row, $event )"></el-button>
                  </el-tooltip>
                  <el-tooltip content="Editace" placement="top" effect="light" :open-delay="500">
                    <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="patient_edit( props.$index, props.row, $event )"></el-button>
                  </el-tooltip>
                  <el-tooltip content="Smazání" placement="top" effect="light" :open-delay="500">
                    <el-button :disabled="!loginuser.admin" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="patient_delete( props.$index, props.row, $event );">
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-pagination
              @size-change="SizeChangePage_pagination_patients"
              @current-change="CurrentChangePage_pagination_patients"
              :current-page.sync="pagination_patients.currentPage"
              :page-sizes="pagination_patients.perPageOptions"
              :page-size="pagination_patients.perPage"
              style="margin-top: 60px; margin-bottom: 60px;"
              :background="true"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination_patients.total"
              align="right">
            </el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row v-if="patient.id_patient > 0" :gutter="60" style="padding-top: 30px;">
      <el-col :span="24" class="card-01">
        <el-tabs type="card" v-model="gs_patient_tab_active" @tab-click="click_patient_tab">
          <el-tab-pane label="Diagnóza/událost" name="vysetreni">
            <examinations v-if="patient.id_patient > 0"></examinations>
          </el-tab-pane>
          <el-tab-pane label="Operace" name="operace">
            <operations v-if="patient.id_patient > 0"></operations>
          </el-tab-pane>
          <el-tab-pane label="Kontroly" name="kontroly">
            <checkups v-if="patient.id_patient > 0"></checkups>
          </el-tab-pane>
          <el-tab-pane label="Léčba" name="lecba">
            <medications v-if="patient.id_patient > 0"></medications>
          </el-tab-pane>
          <el-tab-pane label="Přehledy" name="prehledy">
            <reviews v-if="patient.id_patient > 0"></reviews>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="modal_patient" width="1600px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="false" :close-on-press-escape="false" @closed="closed_modal_patient('form_patient')" >
      <el-form ref="form_patient" size="mini" :rules="rules_patient" :model="patient">

        <div>
        <el-card class="card_modal_patient">
          <el-col :span="4" class="modal_patient_1a" style="text-align: right; padding-right: 30px">

            <div v-if="patient.id_patient < 1">
            <p class="modal_green_small mt-50">Nový</p>
            <h1 class="modal_title light_blue" style="margin-bottom: 0;">Pacient</h1>
            <img style="padding-bottom: 20px" src="img/user_02.png">
            </div>

            <div v-show="modal_patient_ro">
            <p class="modal_green_small mt-50">Jen pro čtení</p>
            <h1 class="modal_title light_blue" style="margin-bottom: 0;">Pacient</h1>
            <img style="padding-bottom: 20px" src="img/user_04.png">
            </div>

            <div v-if="(patient.id_patient > 0) && !modal_patient_ro">
            <p class="modal_green_small mt-50">Editace</p>
            <h1 class="modal_title light_blue" style="margin-bottom: 0;">Pacient</h1>
            <img style="padding-bottom: 20px" src="img/user_04.png">
            </div>

            <div v-if="patient.id_patient > 0">
            <hr class="pat">
            <p class="modal_label dark_green">Diagnóza:</p>
            <p class="modal_white small"><b> {{ patient.d_name }} </b></p>
            <hr class="pat">
            <p class="modal_label dark_green">Datum první diagnózy:</p>
            <p class="modal_white small"><b> {{ patient_panel_a1 }} </b></p>
            <hr class="pat">
            <p class="modal_label dark_green">Lokalikace topo:</p>
            <p class="modal_white small"><b> {{ patient_panel_a2 }} </b></p>
            <hr class="pat">
            <p class="modal_label dark_green">Datum poslední kontroly:</p>
            <p class="modal_white small"><b> {{ patient_panel_b }} </b></p>
            <hr class="pat">
            </div>

          </el-col>
          <el-col :span="20" class="modal_patient_1b" style="padding: 20px">
            <el-row :class="{ modal_1b_ro: modal_patient_ro, modal_1b: !modal_patient_ro }">
              <el-col :span="11">
                <h5 class="modal_dark_blue title-1">
                <span class="fa-stack" style="color: #00134b; padding: 0 10px">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-info fa-stack-1x fa-inverse"></i>
                </span>
                  Osobní údaje
                </h5>
                <el-row class="card-modal white" style="min-height: 280px;">
                  <el-col>
                    <el-row>
                      <el-col :span="11">
                        <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Jméno</div>
                        <el-form-item prop="pat_name">
                          <el-input type="text"
                                    :readonly="modal_patient_ro"
                                    placeholder=""
                                    v-model="patient_pat_name"
                                    size="small"
                                    >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" :offset="1">
                        <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Příjmení</div>
                        <el-form-item prop="pat_surname">
                          <el-input type="text"
                                    :readonly="modal_patient_ro"
                                    placeholder=""
                                    v-model="patient_pat_surname"
                                    size="small"
                                    >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="11">
                        <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Číslo pojištěnce</div>
                        <el-form-item prop="pat_insu_num">
                          <el-input type="text"
                                    placeholder=""
                                    v-model="patient_pat_insu_num"
                                    size="small"
                                    :controls="false"
                                    @change="change_pat_insu_num"
                                    :readonly="modal_patient_ro"
                                    >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" :offset="1">
                        <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Datum narození</div>
                        <el-form-item prop="pat_birth_date">
                          <el-date-picker
                            type="date"
                            placeholder=""
                            v-model="patient_pat_birth_date"
                            format="dd. MM. yyyy"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptionsDate"
                            width="100%"
                            :readonly="modal_patient_ro"
                            clearable
                            >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="11">
                        <div class="modal_label dark_grey"> Pojišťovna</div>
                          <el-select
                            v-model="patient_id_inco"
                            placeholder=""
                            :disabled="modal_patient_ro"
                            style="min-width: 100%"
                            filterable
                            clearable
                            >
                            <el-option
                              v-for="one in l_insurance_companies"
                              :key="one.id_inco"
                              :label="one.inco_name"
                              :value="one.id_inco"
                              width="100%"
                              size="small"
                              >
                            </el-option>
                          </el-select>
                      </el-col>
                      <el-col :span="12" :offset="1">
                        <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Pohlaví</div>
                          <div class="bor-blue-patient">
                            <el-form-item prop="pat_gender">
                              <el-radio-group v-model="patient_pat_gender" :disabled="modal_patient_ro">
                                <el-radio :label="1"><i class="el-icon-user"></i> Žena </el-radio>
                                <el-radio :label="2"><i class="el-icon-user"></i> Muž </el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="20" >
                      <el-col :span="24">
                        <div><span class="modal_label dark_green">*</span> <i>povinné údaje</i></div>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="13">
                <h5 class="modal_dark_blue title-1">
                <span class="fa-stack" style="color: #00134b; padding: 0 10px">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-home fa-stack-1x fa-inverse"></i>
                </span>
                  Kontaktní údaje
                </h5>
                <el-row class="card-modal white" style="min-height: 280px;">
                  <el-col :span="9">
                    <div class="modal_label dark_grey"> Ulice</div>
                    <el-input type="text"
                              v-model="patient_pat_street"
                              size="small"
                              :readonly="modal_patient_ro"
                              >
                    </el-input>
                  </el-col>
                  <el-col :span="6" :offset="1">
                    <div class="modal_label dark_grey"> Číslo</div>
                    <el-input type="text"
                              v-model="patient_pat_street_num"
                              size="small"
                              :readonly="modal_patient_ro"
                              >
                    </el-input>
                  </el-col>
                  <el-col :span="9">
                    <div class="modal_label dark_grey"> Město</div>
                    <el-input type="text"
                              v-model="patient_pat_city"
                              size="small"
                              :readonly="modal_patient_ro"
                              >
                    </el-input>
                  </el-col>
                  <el-col :span="3" :offset="1">
                    <div class="modal_label dark_grey"> PSČ</div>
                    <el-form-item prop="">
                      <el-input type="text"
                                :maxlength="8"
                                v-model="patient_pat_zip_code"
                                size="small"
                                :readonly="modal_patient_ro"
                                >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="1">
                    <div class="modal_label dark_grey"> Země</div>
                    <el-select
                      v-model="patient_pat_country"
                      filterable
                      clearable
                      :disabled="modal_patient_ro"
                    >
                      <el-option
                        v-for="item in l_countries"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="14">
                    <div class="modal_label dark_grey"> E-mail</div>
                    <el-form-item prop="pat_email">
                      <el-input type="text"
                                v-model="patient_pat_email"
                                size="small"
                                :readonly="modal_patient_ro"
                                >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="9" :offset="1">
                    <div class="modal_label dark_grey"> Telefon</div>
                    <el-input type="text"
                              v-model="patient_pat_phone"
                              size="small"
                              :readonly="modal_patient_ro"
                              >
                    </el-input>
                  </el-col>
                </el-row>
              </el-col>
              <el-col style="min-height: 5px; margin-top: 30px">
              </el-col>
              <el-col :span="11">
                <h5 class="modal_dark_blue title-1">
                <span class="fa-stack" style="color: #00134b; padding: 0 10px">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-school fa-stack-1x fa-inverse"></i>
                </span>
                  Škola
                </h5>
                <el-row class="card-modal white">
                  <el-col>
                    <el-row>
                      <el-col :span="9">
                        <div class="modal_label dark_grey">Aktuální vzdělání</div>
                      </el-col>
                      <el-col :span="15">
                        <el-form-item class="">
                          <el-cascader
                            v-model="patient_pat_school"
                            :options="l_pat_skola"
                            placeholder="Vyber variantu"
                            size="small"
                            :disabled="modal_patient_ro"
                            clearable
                          >
                          </el-cascader>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="13">
                <h5 class="modal_dark_blue title-1">
                <span class="fa-stack" style="color: #00134b; padding: 0 10px">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-pencil-alt fa-stack-1x fa-inverse"></i>
                </span>
                  Poznámky
                </h5>
                <el-row class="card-modal white">
                  <el-col :span="12">
                    <div class="modal_label dark_grey">Privátní</div>
                    <textarea rows="4"
                        class="form-control border-input"
                        v-model="patient_pat_privat_note"
                        :readonly="modal_patient_ro"
                        >
                    </textarea>
                  </el-col>
                  <el-col :span="11"  :offset="1">
                    <div class="modal_label dark_grey">Veřejné</div>
                    <textarea rows="4"
                        class="form-control border-input"
                        v-model="patient_pat_public_note"
                        :readonly="modal_patient_ro"
                        >
                    </textarea>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="24" >
                <el-row >
                  <el-col :span="24">
                    <el-row>
                      <el-col>
                        <div style="padding: 20px 20px 80px 20px">
                        <el-row>
                          <el-col :span="16">
                            <div class="card-modal middle_blue">
                              <h5 class="modal_dark_blue title-1">První příznak</h5>
                                <el-row>
                                  <el-col>
                                    <el-checkbox v-model="patient_prvni_priznak_asympt" :disabled="modal_patient_ro" label="Asympt" @change="change_asympt"></el-checkbox>
                                  </el-col>
                                </el-row>
                                <div v-show="!patient_prvni_priznak_asympt">
                                  <el-row>
                                    <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                                      <span>Fokalní deficit</span>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                      <el-form-item class="">
                                        <el-select
                                          v-model="patient_prvni_priznak_fokal_deficit"
                                          multiple
                                          placeholder="Vyber variantu"
                                          @change="vymaz_patient_prvni_priznak_fokal_deficit_jiny_text"
                                          :disabled="modal_patient_ro"
                                          filterable
                                          clearable
                                          >
                                          <el-option
                                            v-for="item in l_pat_cis_prv_priz_fok_def"
                                            :key="item.deficit_nazev"
                                            :label="item.deficit_nazev"
                                            :value="item.deficit_nazev"
                                            >
                                          </el-option>
                                        </el-select>
                                      </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                        <el-form-item class="">
                                          <el-input
                                            :disabled="!(patient_prvni_priznak_fokal_deficit.includes('Jiný'))"
                                            type="textarea"
                                            :rows="3"
                                            v-model="patient_prvni_priznak_fokal_deficit_jiny_text"
                                            placeholder="Popis fokální deficit / jiný"
                                            :readonly="modal_patient_ro"
                                            >
                                          </el-input>
                                        </el-form-item>
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col class="mt-10" :xs="24" :sm="24" :md="4" :lg="4" :xl="4" >
                                      <span>Epilepsie</span>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                      <el-form-item class="bor">
                                        <el-radio v-model="patient_prvni_priznak_epilepsie" :disabled="modal_patient_ro" label="Grandmal" @click.native="click_patient_prvni_priznak_epilepsie" @change="vymaz_patient_prvni_priznak_epilepsie">Grandmal</el-radio>
                                        <el-radio v-model="patient_prvni_priznak_epilepsie" :disabled="modal_patient_ro" label="Jackson" @click.native="click_patient_prvni_priznak_epilepsie" @change="vymaz_patient_prvni_priznak_epilepsie">Jackson</el-radio>
                                        <el-radio v-model="patient_prvni_priznak_epilepsie" :disabled="modal_patient_ro" label="Jiná" @click.native="click_patient_prvni_priznak_epilepsie">Jiná</el-radio>
                                      </el-form-item>
                                    </el-col>
                                    <el-col style="margin-top: 5px;" :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                        <el-form-item class="">
                                          <el-input
                                            :disabled="!(patient_prvni_priznak_epilepsie === 'Jiná')"
                                            type="textarea"
                                            :rows="3"
                                            v-model="patient_prvni_priznak_epilepsie_jiny_text"
                                            placeholder="Popis epilepsie / jiná"
                                            :readonly="modal_patient_ro"
                                            >
                                          </el-input>
                                        </el-form-item>
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                                      <el-checkbox v-model="patient_prvni_priznak_nth" :disabled="modal_patient_ro" label="NTH"></el-checkbox>
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                                      <el-checkbox v-model="patient_prvni_priznak_ataxie" :disabled="modal_patient_ro" label="Ataxie"></el-checkbox>
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                                      <el-checkbox v-model="patient_prvni_priznak_jiny" :disabled="modal_patient_ro" label="Jiný" @change="vymaz_patient_prvni_priznak_jiny_text"></el-checkbox>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                        <el-form-item class="">
                                          <el-input
                                            :disabled="!(patient_prvni_priznak_jiny)"
                                            type="textarea"
                                            :rows="3"
                                            v-model="patient_prvni_priznak_jiny_text"
                                            placeholder="Popis jiný"
                                            :readonly="modal_patient_ro"
                                            >
                                          </el-input>
                                        </el-form-item>
                                    </el-col>
                                  </el-row>
                                </div>
                            </div>
                          </el-col>
                          <el-col :span="8">
                            <div class="card-modal middle_blue">
                              <h5 class="modal_dark_blue title-1">Délka anamnézy</h5>
                                <el-row>
                                  <el-col :span="8">
                                    <span>Počet dní</span>
                                  </el-col>
                                  <el-col :span="12">
                                    <el-input-number
                                        v-model="patient_prvni_priznak_del_anam"
                                        controls-position="right"
                                        size="mini"
                                        :min="0"
                                        :disabled="modal_patient_ro"
                                    >
                                    </el-input-number>
                                  </el-col>
                                </el-row>
                              </div>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <div class="card-modal middle_blue">
                              <h5 class="modal_dark_blue title-1">Syndrom predispozice</h5>
                              <el-row :gutter="10">
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                  <el-radio v-model="patient_syn_pre" :disabled="modal_patient_ro" :label="true">ANO</el-radio>
                                  <el-radio v-model="patient_syn_pre" :disabled="modal_patient_ro" :label="false" @change="vymaz_patient_syn_pre">NE</el-radio>
                                </el-col>
                              </el-row>
                              <el-row class="bor">
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                  <div class="modal_label dark_blue">Syndrom</div>
                                  <el-select
                                    :disabled="modal_patient_ro || !patient_syn_pre"
                                    v-model="patient_syn_pre_var"
                                    placeholder="Vyber variantu"
                                    filterable
                                    clearable
                                    >
                                    <el-option
                                      v-for="item in l_pat_cis_syn_pre_var"
                                      :key="item.id_pat_cis_syn_pre_var"
                                      :label="item.nazev_syndrom"
                                      :value="item.id_pat_cis_syn_pre_var">
                                    </el-option>
                                  </el-select>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                  <div class="modal_label dark_blue">Gen</div>
                                  <el-select
                                    :disabled="modal_patient_ro || !patient_syn_pre"
                                    v-model="patient_syn_pre_gen"
                                    placeholder="Vyber variantu"
                                    filterable
                                    clearable
                                    >
                                    <el-option
                                      v-for="item in l_pat_cis_syn_pre_gen"
                                      :key="item.id_pat_cis_syn_pre_gen"
                                      :label="item.nazev_gen"
                                      :value="item.id_pat_cis_syn_pre_gen"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                                  <div class="modal_label dark_blue">Zápis mutace</div>
                                  <el-form-item class="">
                                    <el-input
                                      :disabled="modal_patient_ro || !patient_syn_pre"
                                      type="textarea"
                                      :rows="3"
                                      v-model="patient_syn_pre_gen_dal"
                                      placeholder="Popis"
                                      :readonly="modal_patient_ro"
                                      >
                                    </el-input>
                                  </el-form-item>
                                  </el-col>
                              </el-row>
                            </div>
                          </el-col>
                          <el-col :span="16">
                            <div class="card-modal middle_blue">
                              <h5 class="modal_dark_blue title-1">Aktuální stav onemocnění</h5>
                              <el-row :gutter="10" class="bor">
                                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                  <el-radio-group v-model="patient_ak_st_on" @change="vymaz_patient_ak_st_on" :disabled="modal_patient_ro">
                                    <el-radio label="1" @click.native="click_patient_ak_st_on">CR</el-radio>
                                    <el-radio label="2" @click.native="click_patient_ak_st_on">PR</el-radio>
                                    <el-radio label="3" @click.native="click_patient_ak_st_on">SD</el-radio>
                                    <el-radio label="4" @click.native="click_patient_ak_st_on">PD</el-radio>
                                  </el-radio-group>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9" style="padding-top: 15px;">
                                  <el-form-item class="">
                                    <el-date-picker
                                      :disabled="modal_patient_ro || !(patient_ak_st_on === '4')"
                                      v-model="patient_ak_st_on_pd_dat"
                                      type="date"
                                      format="dd. MM. yyyy"
                                      value-format="yyyy-MM-dd"
                                      :picker-options="pickerOptionsDate"
                                      placeholder="Vyber datum"
                                      width="100%"
                                      clearable
                                      >
                                    </el-date-picker>
                                  </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9" style="float: right; padding-top: 20px;">
                                  <el-radio :disabled="modal_patient_ro || !(patient_ak_st_on === '4')" v-model="patient_ak_st_on_pd_pr" :label="true">Progrese</el-radio>
                                  <el-radio :disabled="modal_patient_ro || !(patient_ak_st_on === '4')" v-model="patient_ak_st_on_pd_pr" :label="false">Recidiva</el-radio>
                                </el-col>
                              </el-row>
                              <el-row :gutter="10" class="bor">
                                <el-col>
                                  <el-row>
                                    <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                                      <div class="modal_dark_blue title-2">Úmrtí</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                                      <el-form-item class="">
                                        <el-date-picker
                                          v-model="patient_ak_st_on_um_dat"
                                          type="datetime"
                                          format="dd. MM. yyyy HH:mm"
                                          value-format="yyyy-MM-dd HH:mm:ss"
                                          :picker-options="pickerOptions"
                                          placeholder="Vyber datum"
                                          width="100%"
                                          :disabled="modal_patient_ro"
                                          clearable
                                          >
                                        </el-date-picker>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>
                                </el-col>
                                <el-col>
                                  <el-row>
                                    <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                                      <div class="modal_dark_blue title-2">Důvod</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19">
                                      <el-select
                                        :disabled="modal_patient_ro"
                                        v-model="patient_ak_st_on_um_du"
                                        placeholder="Vyber variantu"
                                        @change="vymaz_patient_ak_st_on_um_du_jiny"
                                        filterable
                                        clearable
                                        >
                                        <el-option
                                          v-for="item of pat_ak_st_on_um_du_v"
                                          :key="item"
                                          :label="item"
                                          :value="item"
                                          >
                                        </el-option>
                                      </el-select>
                                    </el-col>
                                  </el-row>
                                </el-col>
                                <el-col>
                                  <el-row>
                                    <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                                      <div class="modal_dark_blue title-2">Jiný</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                                      <el-form-item class="">
                                        <el-input
                                          :disabled="modal_patient_ro || patient_ak_st_on_um_du !== 'jiný'"
                                          type="textarea"
                                          :rows="2"
                                          v-model="patient_ak_st_on_um_du_jiny"
                                          placeholder="Popis">
                                        </el-input>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>
                                </el-col>
                              </el-row>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <div class="card-modal middle_blue">
                              <h5 class="modal_dark_blue title-1">Follow-up</h5>
                              <el-row :gutter="10" class="bor">
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                  <div class="modal_label dark_blue">Datum</div>
                                  <el-form-item class="">
                                    <el-date-picker
                                      v-model="patient_foll"
                                      type="date"
                                      format="dd. MM. yyyy"
                                      value-format="yyyy-MM-dd"
                                      :picker-options="pickerOptionsDate"
                                      placeholder="Vyber datum"
                                      width="100%"
                                      :disabled="modal_patient_ro"
                                      clearable
                                      >
                                    </el-date-picker>
                                  </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                  <div class="modal_label dark_blue">Od 1. diagnózy</div>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                  <div class="sum left" style="min-height: 28px"><b> {{ patient_prvni_diagnoza }}</b></div>
                                </el-col>
                              </el-row>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row>

                          <el-col style="min-height: 5px; margin-top: 30px">
                          </el-col>

                        </el-row>
                        </div>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-card>
        </div>

        <div class="text-center mt-3">
        <el-button v-if="patient.id_patient < 1" class="btn-green-big" link @click.native="patient_new_save"><i class="el-icon-finished"></i> ULOŽIT </el-button>
        <el-button v-if="(patient.id_patient > 0) && !modal_patient_ro" type="info" link @click.native="patient_edit_save"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
        <el-button class="btn-blue" link @click.native="modal_patient_close('form_patient')"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
        </div>

      </el-form>
    </el-dialog>

  </div>

</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import Examinations from 'src/components/Views/Examinations.vue';
  import Operations from 'src/components/Views/Operations.vue';
  import Checkups from 'src/components/Views/Checkups.vue';
  import Medications from 'src/components/Views/Medications.vue';
  import Reviews from 'src/components/Views/Reviews.vue';

  const nthOptions = ['Cefalea', 'Porucha vědomí'];

  export default {
    components: {
      Examinations,
      Operations,
      Checkups,
      Medications,
      Reviews

    },

    data () {
      return {

        checkup_show: false,

        pickerOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Dnes',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: 'Včera',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: 'Minulý týden',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },


        pickerOptionsDate: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Dnes',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }]
        },


        rules_patient: {
          pat_name: [
            { required: true, message: 'Jméno je vyžadováno', trigger: 'blur' },
          ],
          pat_surname: [
            { required: true, message: 'Příjmení je vyžadováno', trigger: 'blur' },
          ],
          pat_email: [
            { type: "email", message: 'E-mail není ve správném tvaru', trigger: 'blur'  },
          ],
          pat_birth_date: [
            { required: true, message: 'Datum narození je vyžadováno', trigger: 'blur' },
          ],
          pat_gender: [
            { required: true, message: 'Pohlaví je vyžadováno', trigger: 'blur' },
          ],
          pat_insu_num: [
            { required: true, message: 'Číslo pojištěnce je vyžadováno', trigger: 'blur' },
            { pattern:/^[0-9][0-9]((0[1-9])|(1[0-2])|(5[1-9])|(6[0-2]))((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1])|(5[1-9])|(6[0-9])|(7[0-9])|(8[0-1]))[0-9]{3,4}$/, message: 'Špatný formát RČ', trigger: 'blur' },

          ],

        },

      }
    },


    computed: {
      ...mapState({
        loginuser: state => state.loginuser,

        patient: state => state.patient,
        patient_panel_a1: state => state.patient_panel_a1,
        patient_panel_a2: state => state.patient_panel_a2,
        patient_panel_b: state => state.patient_panel_b,
        patient_default: state => state.patient_default,
        patients: state => state.patients,
        modal_patient_ro: state => state.modal_patient_ro,
        filter_patients: state => state.filter_patients,

        examination: state => state.examination,
        examination_default: state => state.examination_default,
        examinations: state => state.examinations,
        sorting_patients: state => state.sorting_patients,
        pagination_patients: state => state.pagination_patients,
        loading_patients: state => state.loading_patients,
        patient_tab_active: state => state.patient_tab_active,

        pat_ak_st_on_um_du_v: state => state.pat_ak_st_on_um_du_v,
        pat_vek_v: state => state.pat_vek_v,

        l_insurance_companies: state => state.l_insurance_companies,
        l_exam_diagnozy: state => state.l_exam_diagnozy,
        l_countries: state => state.l_countries,
        l_diags: state => state.l_diags,

        l_pat_cis_syn_pre_var: state => state.l_pat_cis_syn_pre_var,
        l_pat_cis_syn_pre_gen: state => state.l_pat_cis_syn_pre_gen,
        l_pat_cis_prv_priz_fok_def: state => state.l_pat_cis_prv_priz_fok_def,
        l_pat_skola: state => state.l_pat_skola,

      }),

      ...mapGetters({
        g_exam_diagnozy: 'g_exam_diagnozy',

      }),

      modal_patient: {
        get() { return this.$store.state.modal_patient; },
        set(value) { this.$store.commit('m_modal_patient', value); }
      },

      filter_select_column: {
        get () { return this.$store.state.filter_select_column; },
        set (value) { this.$store.commit('m_filter_select_column', value); }
      },


      patient_pat_name: {
        get () { return this.patient.pat_name; },
        set (value) { let mykey = "pat_name"; this.m_patient_item( {mykey, value} ); }
      },

      patient_prvni_diagnoza: {
        get() { return this.patient.prvni_diagnoza; },
        set(value) { let mykey = "prvni_diagnoza"; this.m_patient_item({ mykey, value }); }
      },

      patient_pat_surname: {
        get () { return this.patient.pat_surname; },
        set (value) { let mykey = "pat_surname"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_insu_num: {
        get () { return this.patient.pat_insu_num; },
        set (value) { let mykey = "pat_insu_num"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_birth_date: {
        get () { return this.patient.pat_birth_date; },
        set (value) { let mykey = "pat_birth_date"; this.m_patient_item( {mykey, value} ); }
      },

      patient_id_inco: {
        get () { return this.patient.id_inco; },
        set (value) { let mykey = "id_inco"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_gender: {
        get () { return this.patient.pat_gender; },
        set (value) { let mykey = "pat_gender"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_street: {
        get () { return this.patient.pat_street; },
        set (value) { let mykey = "pat_street"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_street_num: {
        get () { return this.patient.pat_street_num; },
        set (value) { let mykey = "pat_street_num"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_city: {
        get () { return this.patient.pat_city; },
        set (value) { let mykey = "pat_city"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_zip_code: {
        get () { return this.patient.pat_zip_code; },
        set (value) { let mykey = "pat_zip_code"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_country: {
        get () { return this.patient.pat_country; },
        set (value) { let mykey = "pat_country"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_email: {
        get () { return this.patient.pat_email; },
        set (value) { let mykey = "pat_email"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_phone: {
        get () { return this.patient.pat_phone; },
        set (value) { let mykey = "pat_phone"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_privat_note: {
        get () { return this.patient.pat_privat_note; },
        set (value) { let mykey = "pat_privat_note"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_public_note: {
        get () { return this.patient.pat_public_note; },
        set (value) { let mykey = "pat_public_note"; this.m_patient_item( {mykey, value} ); }
      },

      patient_pat_school: {
        get () { return this.patient.pat_school; },
        set (value) { let mykey = "pat_school"; this.m_patient_item( {mykey, value} ); }
      },

      patient_prvni_priznak_asympt: {
        get () { return this.patient.prvni_priznak_asympt; },
        set (value) { let mykey = "prvni_priznak_asympt"; this.m_patient_item( { mykey, value } ); }
      },

      patient_prvni_priznak_fokal_deficit: {
        get () { return this.patient.prvni_priznak_fokal_deficit; },
        set (value) { let mykey = "prvni_priznak_fokal_deficit"; this.m_patient_item( { mykey, value } ); }
      },

      patient_prvni_priznak_fokal_deficit_jiny_text: {
        get () { return this.patient.prvni_priznak_fokal_deficit_jiny_text; },
        set (value) { let mykey = "prvni_priznak_fokal_deficit_jiny_text"; this.m_patient_item( { mykey, value } ); }
      },

      patient_prvni_priznak_epilepsie: {
        get () { return this.patient.prvni_priznak_epilepsie; },
        set (value) { let mykey = "prvni_priznak_epilepsie"; this.m_patient_item( { mykey, value } ); }
      },

      patient_prvni_priznak_epilepsie_jiny_text: {
        get () { return this.patient.prvni_priznak_epilepsie_jiny_text; },
        set (value) { let mykey = "prvni_priznak_epilepsie_jiny_text"; this.m_patient_item( { mykey, value } ); }
      },

      patient_prvni_priznak_nth: {
        get () { return this.patient.prvni_priznak_nth; },
        set (value) { let mykey = "prvni_priznak_nth"; this.m_patient_item( { mykey, value } ); }
      },

      patient_prvni_priznak_ataxie: {
        get () { return this.patient.prvni_priznak_ataxie; },
        set (value) { let mykey = "prvni_priznak_ataxie"; this.m_patient_item( { mykey, value } ); }
      },

      patient_prvni_priznak_jiny: {
        get () { return this.patient.prvni_priznak_jiny; },
        set (value) { let mykey = "prvni_priznak_jiny"; this.m_patient_item( { mykey, value } ); }
      },

      patient_prvni_priznak_jiny_text: {
        get () { return this.patient.prvni_priznak_jiny_text; },
        set (value) { let mykey = "prvni_priznak_jiny_text"; this.m_patient_item( { mykey, value } ); }
      },

      patient_prvni_priznak_del_anam: {
        get () { return this.patient.prvni_priznak_del_anam; },
        set (value) { let mykey = "prvni_priznak_del_anam"; this.m_patient_item( { mykey, value } ); }
      },


      patient_syn_pre: {
        get () { return this.patient.syn_pre; },
        set (value) { let mykey = "syn_pre"; this.m_patient_item( { mykey, value } ); }
      },

      patient_syn_pre_var: {
        get () { return this.patient.syn_pre_var; },
        set (value) { let mykey = "syn_pre_var"; this.m_patient_item( { mykey, value } ); }
      },

      patient_syn_pre_gen: {
        get () { return this.patient.syn_pre_gen; },
        set (value) { let mykey = "syn_pre_gen"; this.m_patient_item( { mykey, value } ); }
      },

      patient_syn_pre_gen_dal: {
        get () { return this.patient.syn_pre_gen_dal; },
        set (value) { let mykey = "syn_pre_gen_dal"; this.m_patient_item( { mykey, value } ); }
      },

      patient_ak_st_on: {
        get () { return this.patient.ak_st_on; },
        set (value) { let mykey = "ak_st_on"; this.m_patient_item( { mykey, value } ); }
      },

      patient_ak_st_on_pd_dat: {
        get () { return this.patient.ak_st_on_pd_dat; },
        set (value) { let mykey = "ak_st_on_pd_dat"; this.m_patient_item( { mykey, value } ); }
      },

      patient_ak_st_on_pd_pr: {
        get () { return this.patient.ak_st_on_pd_pr; },
        set (value) { let mykey = "ak_st_on_pd_pr"; this.m_patient_item( { mykey, value } ); }
      },

      patient_ak_st_on_um_dat: {
        get () { return this.patient.ak_st_on_um_dat; },
        set (value) { let mykey = "ak_st_on_um_dat"; this.m_patient_item( { mykey, value } ); }
      },

      patient_ak_st_on_um_du: {
        get () { return this.patient.ak_st_on_um_du; },
        set (value) { let mykey = "ak_st_on_um_du"; this.m_patient_item( { mykey, value } ); }
      },

      patient_ak_st_on_um_du_jiny: {
        get () { return this.patient.ak_st_on_um_du_jiny; },
        set (value) { let mykey = "ak_st_on_um_du_jiny"; this.m_patient_item( { mykey, value } ); }
      },

      patient_foll: {
        get () { return this.patient.foll; },
        set (value) { let mykey = "foll"; this.m_patient_item( { mykey, value } ); }
      },

      gs_patient_tab_active: {
        get () { return this.patient_tab_active; },
        set (value) { this.m_patient_tab_active( value ); }
      },

    },

    methods: {
      ...mapMutations({
        m_patient: 'm_patient',
        m_modal_patient_ro: 'm_modal_patient_ro',
        m_patient_item: 'm_patient_item',
        m_patient_id: 'm_patient_id',
        m_modal_patient: 'm_modal_patient',
        m_patient_reset: 'm_patient_reset',
        m_patient_tab_active: 'm_patient_tab_active',
        m_patient_pat_birth_date: 'm_patient_pat_birth_date',
        m_patient_pat_gender: 'm_patient_pat_gender',
        m_filter_patients: 'm_filter_patients',

        m_examinations: 'm_examinations',
        m_operations: 'm_operations',
        m_checkups: 'm_checkups',
        m_medications: 'm_medications',
        m_patient_reset: 'm_patient_reset',

      }),


      ...mapActions({
        a_patient: 'a_patient',
        a_patient_new: 'a_patient_new',
        a_patient_update: 'a_patient_update',
        a_patient_delete: 'a_patient_delete',
        a_patients: 'a_patients',
        a_examinations: 'a_examinations',
        a_operations: 'a_operations',
        a_checkups: 'a_checkups',
        a_medications: 'a_medications',
        a_reviews: 'a_reviews',
        a_pat_cis_syn_pre_var: 'a_pat_cis_syn_pre_var',
        a_pat_cis_syn_pre_gen: 'a_pat_cis_syn_pre_gen',
        a_pat_cis_prv_priz_fok_def: 'a_pat_cis_prv_priz_fok_def',
        a_pat_skola: 'a_pat_skola',

      }),


      click_patient_tab(tab, event) {
        if (tab.name === "lecba") {
          this.a_medications();
        } else if  (tab.name === "vysetreni") {
          this.a_examinations();
        } else if  (tab.name === "operace") {
          this.a_operations();
        } else if  (tab.name === "kontroly") {
          this.a_checkups();
        } else if (tab.name === "prehledy") {
          this.a_reviews();
        }
        this.m_patient_tab_active(tab.name);
      },


      onSubmit() {
        console.log('submit!');
      },


     vymaz_patient_ak_st_on_pd_pr(value) {
       this.patient.ak_st_on_pd_pr = null;
       this.patient.ak_st_on_pd_dat = null;
      },


      vymaz_patient_ak_st_on_um_du_jiny(value) {
        if (value !== "jiný") {
          this.patient.ak_st_on_um_du_jiny = "";
        }
      },


      vymaz_patient_prvni_priznak_fokal_deficit_jiny_text(value) {
        if (!value.includes("jiný")) {
          this.patient.prvni_priznak_fokal_deficit_jiny_text = null;
        }
      },


      vymaz_patient_prvni_priznak_epilepsie(value) {
        this.patient.prvni_priznak_epilepsie_jiny_text = null;
      },


      vymaz_patient_prvni_priznak_jiny_text(value) {
        if (value === false) {
          this.patient.prvni_priznak_jiny_text = null;
        }
      },


      vymaz_patient_syn_pre() {
        this.patient.syn_pre_var = null;
        this.patient.syn_pre_gen = null;
        this.patient.syn_pre_gen_dal = null;
      },


      change_asympt(value) {
        if (value == true) {
          this.patient.prvni_priznak_fokal_deficit = [];
          this.patient.prvni_priznak_fokal_deficit_jiny_text = null;
          this.patient.prvni_priznak_epilepsie = null;
          this.patient.prvni_priznak_epilepsie_jiny_text = null;
          this.patient.prvni_priznak_nth = null;
          this.patient.prvni_priznak_ataxie = null;
          this.patient.prvni_priznak_jiny = null;
          this.patient.prvni_priznak_jiny_text = null;
          this.patient.prvni_priznak_del_anam = null;
        }
      },


      change_pat_insu_num(value) {
        let validni = true

        if ((value.length  > 5) && (/^0?\d+$/.test(value))) {
          let yy = '';
          let mm = '';
          let dd = '';

          for (let strIndex in value) {
            if (strIndex == 0) {
              yy += value[strIndex];
            }
            else if (strIndex == 1) {
              yy += value[strIndex];
            }
            else if (strIndex == 2) {
              mm += value[strIndex];
            }
            else if (strIndex == 3) {
              mm += value[strIndex];
            }
            else if (strIndex == 4) {
              dd += value[strIndex];
            }
            else if (strIndex == 5) {
              dd += value[strIndex];
            } else {

            }
          }
          let xyy = parseInt(yy);
          let xmm = parseInt(mm);
          let xdd = parseInt(dd);
          let xgender = "";

          if (xyy > 21) {
            xyy = 1900 + xyy;
          } else {
            xyy = 2000 + xyy;
          }

          if (xmm < 13) {
            xgender = 2;
            xmm -= 1;
          } else if (xmm > 50 && xmm < 63) {
            xgender = 1;
            xmm -= 51;
          } else {
            xgender = 0;
            xmm = 0;
          }

          if (xdd > 31) {
            xdd -= 50;
          }

          this.m_patient_pat_birth_date( {xyy: xyy, xmm: xmm, xdd: xdd});
          this.m_patient_pat_gender(xgender);
        }
      },


      patient_new() {
        this.$refs["patients_table"].setCurrentRow();
        this.m_modal_patient_ro(false);
        this.a_pat_cis_syn_pre_var();
        this.a_pat_cis_syn_pre_gen();
        this.a_pat_cis_prv_priz_fok_def();
        this.a_pat_skola();
        this.m_patient_reset();
        this.m_modal_patient(true);
      },


      patient_show (index, row, event) {
        this.m_modal_patient_ro(true);
        this.m_patient_reset();
        this.patient.id_patient = row.id_patient;
        this.a_patient( {'id_patient': row.id_patient} );
        this.m_modal_patient(true);
      },


      patient_new_save() {
        this.$refs["form_patient"].validate((valid) => {
          if (valid) {
            this.a_patient_new( this.patient );
            this.m_modal_patient(false);
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      patient_edit (index, row, event) {
        this.m_modal_patient_ro(false);
        this.a_pat_cis_syn_pre_var();
        this.a_pat_cis_syn_pre_gen();
        this.a_pat_cis_prv_priz_fok_def();
        this.a_pat_skola();
        this.a_patient( {'id_patient': row.id_patient} );
        this.m_modal_patient(true);
      },


      patient_edit_save() {
        this.$refs["form_patient"].validate((valid) => {
          if (valid) {
            this.m_modal_patient(false);
            this.a_patient_update(this.patient);
            this.a_patients({});
          } else {
            this.$alert('Některá povinná pole nejsou vyplněna!', 'Pozor', {
              confirmButtonText: 'OK',
              dangerouslyUseHTMLString: true
            });
            return false;
          }
        });
      },


      patient_delete (index, row, event) {
        event.stopPropagation();

        this.$confirm(`Opravdu chcete smazat pacienta <b>${row.pat_fullname}</b>?`, 'Warning', {
          confirmButtonText: 'ANO',
          cancelButtonText: 'NE',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.a_patient_delete( {'id_patient': row.id_patient} );
          this.a_patients( {} );
          this.$refs["patients_table"].setCurrentRow();
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: 'Smazání pacienta přerušeno.'
          // });
        });
      },


      modal_patient_close(form_name) {
        this.m_modal_patient(false);
        this.$refs[form_name].clearValidate();
      },

      closed_modal_patient(form_name) {
        this.m_modal_patient_ro(false);
        this.m_modal_patient(false);
        this.$refs[form_name].clearValidate();
      },


      vymaz_patient_ak_st_on(val) {
        if (val !== "PD") {
          this.patient.ak_st_on_pd_dat = "";
          this.patient.ak_st_on_pd_pr = null;
        }
      },


      click_patient_ak_st_on(event) {
        let xxx = event.srcElement._value;
        if (xxx === this.patient_ak_st_on) {
          this.patient.ak_st_on = "";
          this.patient.ak_st_on_pd_dat = null;
        }
      },


      click_patient_prvni_priznak_epilepsie(event) {
        let xxx = event.srcElement._value;
        if (xxx === this.patient.prvni_priznak_epilepsie) {
          this.patient.prvni_priznak_epilepsie = null;
        }
      },


      filter_patient_clear() {
        this.filter_patients.name = "";
        this.filter_patients.dat_diag = null;
        this.filter_patients.diags = null;
        this.filter_patients.vek_od = null;
        this.filter_patients.vek_do = null;
        this.a_patients( {} );
      },


     CurrentChange_patients(val) {
        console.log(val);
        if (val) {
          if (val.id_patient > 0) {
            this.m_patient_id(val.id_patient);
            this.a_patient( {'id_patient': val.id_patient} );
            this.a_examinations();
            this.a_operations();
            this.a_checkups();
            this.a_medications();
            this.a_reviews();
            this.m_patient_tab_active("vysetreni");
          } else {
            this.m_patient_id(0);
          }
        } else {
          this.m_patient_id(0);
        }
      },


      SortChange_patients(val) {
        this.sorting_patients.sorting_prop = val.prop;
        this.sorting_patients.sorting_ordering = val.order;
        this.pagination_patients.currentPage = 1;
        this.a_patients();
      },


      CurrentChangePage_pagination_patients(val) {
        this.pagination_patients.currentPage = val;
        this.a_patients();
      },


      SizeChangePage_pagination_patients(val) {
        this.pagination_patients.perPage = val;
        this.pagination_patients.currentPage = 1;
        this.a_patients();
      },


    },


    beforeCreate () {
    },

    created () {
    },

    beforeMount () {
    },

    mounted () {
      this.a_patients( {} );
      this.m_examinations([]);
      this.m_operations([]);
      this.m_checkups([]);
      this.m_medications([]);
      this.m_patient_reset();
    },

    beforeUpdate () {
    },

    updated () {

    },

    afterDestroy () {
    },

    destroyed () {
    },


  }
</script>

<style lang="scss">


.card_modal_patient {
  background: #00134b !important;
  border: 0px solid #e1ecf2 !important;
  margin: 20px !important;
  border-radius: 20px !important;
  box-shadow: 5px 5px 5px #cdd1dd !important;
}

.modal_patient_1a {
  background: #00134b !important;
  padding-right: 40px !important;
}

.modal_patient_1b {
  background-color: #e1ecf2 !important;
}

.modal_1b_ro {
  padding: 25px;
  background-image: url('/img/pokus_01.png');
  background-repeat: repeat;
}

.el-card__body {
  padding: 0 !important;
}

.bor-blue-patient {
  margin-top: 0 !important;
  padding: 5px 5px 3px 5px !important;
  border-radius: 5px !important;
  border: 1px solid #b7c0db !important;
}

.el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #7b8d9f;
}

.el-radio__input.is-disabled+span.el-radio__label {
    color: #7b8d9f;
}

.el-loading-spinner i {
  font-size: 70px !important;
}

.el-loading-spinner {
  top: 25% !important;
}

</style>
